// src/web/routes/_authenticated/collections/$collectionId.tsx
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { CollectionDetail } from '@/components/features/CollectionDetail'

export const Route = createFileRoute('/_authenticated/collections/$collectionId')({
	component: CollectionDetailPage,
})

function CollectionDetailPage() {
	const { collectionId } = Route.useParams()
	const navigate = useNavigate()

	const handleDeleteSuccess = () => {
		navigate({ to: '/collections' })
	}

	return (
		<CollectionDetail
			collectionId={collectionId}
			className="h-full"
			onDeleteSuccess={handleDeleteSuccess}
		/>
	)
}
